module.exports = __webpack_public_path__ + "img/am-spring-banner.f563ccf6.jpg";